import service from '@/services/compras/autoEmail'

export const state = () => ({
  list: [],
  pageInfo: {},
  currentRow: null,
  item: {}
})

export const mutations = {
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  readByEmisor: ({ commit, rootGetters, dispatch, state }, { restart = false, limit = 10, searchString }) => {
    if (restart) dispatch('resetList')

    return service.readByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, searchString).then(result => {
      commit('SET_LIST', result)

      return result
    })
  },
  readById: ({ state }, { _id }) => {
    return service.readById(_id).then(result => {
      state.item = result

      return result
    })
  }
}
